import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

/** Botón "Buscar" / CTA en filas de filtros (medium). */
export const FilterToolbarGradientButton = styled(Button)(({ theme }) => ({
  borderRadius: theme.spacing(1.5),
  textTransform: 'none',
  fontWeight: 600,
  padding: theme.spacing(1, 2.5),
  transition: 'all 0.2s ease-in-out',
  minWidth: 120,
  boxShadow: 'none',
  background: theme.gradients.primaryCta,
  color: theme.palette.common.white,
  '&:hover': {
    background: theme.gradients.primaryCtaHover,
    transform: 'translateY(-2px)',
    boxShadow: '0 8px 25px rgba(0, 0, 0, 0.15)',
  },
}));

/** Reiniciar / Más / secundarios en toolbar de filtros. */
export const FilterToolbarOutlinedButton = styled(Button)(({ theme }) => ({
  borderRadius: theme.spacing(1.5),
  textTransform: 'none',
  fontWeight: 600,
  padding: theme.spacing(1, 2.5),
  transition: 'all 0.2s ease-in-out',
  minWidth: 120,
  borderColor: theme.palette.divider,
  color: theme.palette.text.secondary,
  backgroundColor: theme.palette.background.paper,
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
    color: theme.palette.text.primary,
    borderColor: theme.palette.divider,
    boxShadow: theme.shadows[1],
    transform: 'translateY(-2px)',
  },
}));
